<template>
  <div>
    <!-- Search Input -->
    <div>
      <b-input-group class="input-group-merge">
        <b-input-group-prepend is-text>
          <feather-icon icon="SearchIcon" />
        </b-input-group-prepend>
        <b-form-input
          v-model="keyword"
          placeholder="Search"
          debounce="500"
        />
      </b-input-group>
    </div>

    <!-- Result -->
    <div class="my-2">
      <div
        v-show="!loading && keyword && !data.length"
        class="text-center mt-2"
      >
        Pencarian "{{ keyword }}" tidak ditemukan
      </div>

      <div
        v-show="!data.length && !keyword && !loading"
        class="text-center mt-2"
      >
        Tidak ada data
      </div>

      <div>
        <slot
          name="item"
          :data="data"
          :loading="loading"
        />
      </div>

      <div class="text-center">
        <b-spinner
          v-show="loading"
          variant="primary"
          small
        />
      </div>
    </div>

    <!-- Load More -->
    <div
      v-show="data.length && meta.last_page > meta.current_page"
      class="text-center"
    >
      <b-button
        v-ripple.400="'rgba(30, 30, 30, 0.15)'"
        variant="flat-dark"
        :disabled="isLoadingLoadMore"
      >
        <b-spinner
          v-show="isLoadingLoadMore"
          small
        />
        Lihat lebih banyak
      </b-button>
    </div>

    <div
      v-show="data.length && meta.last_page === meta.current_page && data.length >= meta.per_page"
      class="text-center"
    >
      Menampilkan seluruh hasil
    </div>
  </div>
</template>

<script>
import {
  BSpinner,
  BInputGroup,
  BFormInput,
  BInputGroupPrepend,
  BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BSpinner,
    BInputGroup,
    BFormInput,
    BInputGroupPrepend,
    BButton,
  },
  directives: {
    Ripple,
  },
  props: {
    state: {
      type: String,
      required: true,
    },
    filter: {
      type: Object,
      default: () => {},
    },
    selected: {
      type: Array,
      default: () => [],
    },
    hideSelected: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      isLoadingLoadMore: false,
      data: [],
      meta: {
        current_page: 1,
        last_page: 1,
        per_page: 20,
      },
      keyword: '',
    }
  },
  watch: {
    async keyword(val) {
      this.data = []
      if (val) {
        this.loadData({
          search: true, keyword: val, page: 1, filter: this.filter,
        })
      }
      if (!val) this.loadData({ search: false, page: 1, filter: this.filter })
    },
  },
  mounted() {
    this.loadData({ filter: this.filter })
  },
  methods: {
    async loadData({
      search = false, keyword = '', page = 1, filter = undefined,
    } = {}) {
      this.loading = true
      const response = await this.$store.dispatch(this.state, { keyword, page, ...filter })
      let { data } = response

      if (this.hideSelected && response) {
        data = data.filter(ar => !this.selected.find(rm => (rm.id === ar.id)))
      }

      if (search && response) {
        this.data = data
      }

      if (!search && response) {
        this.data = [...this.data, ...data]
        this.meta = response.meta
      }
      this.loading = false
    },
    loadMore() {},
  },
}
</script>
